var map = {
	"./icon-1.svg": "b345",
	"./icon-2.svg": "0357",
	"./icon-3.svg": "6e3c",
	"./icon-4.svg": "64c8",
	"./icon-5.svg": "8779",
	"./icon-6.svg": "99fb",
	"./icon-7.svg": "303d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8168";